// https://www.multicall3.com/
export const MULTICALL_ADDRESS = '0xca11bde05977b3631167028862be2a173976ca11'

export const DEFAULT_BATCH_SIZE = 200
